export default __webpack_public_path__ + "static/media/myp.96588b21.svg";